import { Component } from '@angular/core';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout class="black">
      <nb-layout-header fixed >
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar shadow-none" tag="menu-sidebar">
        <ng-content select="ngx-repo-tree-sidebar"></ng-content>
      </nb-sidebar>

      <nb-layout-column class="p-1">
        <!--img src="https://preview.uideck.com/items/saaspal/assets/img/about/about-right-shape.svg" class="position-absolute" style="right: -10%; bottom:-15%; z-index: 0" -->
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed class="d-none">
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent {}
